import { AnyAction } from '@reduxjs/toolkit'

import {
  AGGREGATE_AUDIT_EVENTS_SUCCESS,
  FETCH_AUDIT_LOGS_SUCCESS,
  FETCH_AUDIT_SEARCH_USERS_SUCCESS
} from './actionTypes'

type OrganizationAuditPageState = {
  searchedUsers: any[]
  audit?: any
  auditTotalCount?: number
  auditStartIndex?: number
  offset?: number
  events?: any[]
}

export const initialState: OrganizationAuditPageState = { searchedUsers: [] }

export default (state = initialState, action: AnyAction): OrganizationAuditPageState => {
  switch (action.type) {
    case FETCH_AUDIT_LOGS_SUCCESS: {
      return {
        ...state,
        audit: action.response.results,
        auditTotalCount: action.response.totalResults.value,
        auditStartIndex: action.response.startIndex === 0 ? 1 : Number.parseInt(action.response.startIndex, 10),
        offset: action.response.offset
      }
    }
    case AGGREGATE_AUDIT_EVENTS_SUCCESS: {
      return {
        ...state,
        events: action.response
      }
    }
    case FETCH_AUDIT_SEARCH_USERS_SUCCESS: {
      return { ...state, searchedUsers: action.response.resources.map(({ id }: { id: string }) => id) }
    }
    default: {
      return state
    }
  }
}
